import { useState } from "react";
import { EstudianteActivoDTO, VoidEstudianteActivoDTO } from "../../interfaces/SAAC/EstudianteActivoDTO";
import { Alert, Button, Container, Grid, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import AcademicoService from "../../services/AcademicoService";
import { MdPersonSearch } from "react-icons/md";
import { MdOutlineCleaningServices } from "react-icons/md";
import { EstudianteActivoValidate } from "../ValidationForm/validationForm";
import EstudiantesTabla from "./EstudianteTabla";

interface Props {
    token: any,
    ocultarBoton: boolean,
    tipo: string,
    onResponse?: (dataRespuesta: any) => void // Función para pasar la respuesta al padre
    onClean?: (dataRespuesta: any) => void // Función para pasar la respuesta al padre
}

const academicoService = new AcademicoService();

export const EstudianteActivo: React.FC<Props> = ({ token, ocultarBoton, tipo, onResponse, onClean }) => {
    let [estudiante, setEstudiante] = useState<EstudianteActivoDTO>(VoidEstudianteActivoDTO());
    const formik = useFormik({
        initialValues: {
            codestudiante: ''
        },
        validationSchema: EstudianteActivoValidate,
        onSubmit: (values) => {
            consultar(values.codestudiante);
        },
    });

    async function consultar(codestudiante: string) {
        const resp = await academicoService.GetCarreraActivaByMatricula(token, codestudiante, tipo);
        if (resp.status.isSuccessfully) {
            //console.log(resp.data);
            setEstudiante(resp.data);
            if (onResponse) {
                onResponse(resp.data);
            } else {
                console.error('La función onResponse no está definida.');
            }
        } else {
            console.error(resp.status.messages)
        }
    }

    function limpiar() {
        if (onClean) {
            formik.setFieldValue('codestudiante', '');
            setEstudiante(VoidEstudianteActivoDTO());
            onClean(false);
        } else {
            formik.setFieldValue('codestudiante', '');
            console.error('La función onClean no está definida.');
        }
    }

    return (
        <>
            <Container maxWidth="lg" style={{ border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', textAlign: 'center' }}>
                <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: '#517ED3' }}>
                    Consulta de estudiante
                </Typography>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        {/* Tema del Proyecto */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="codestudiante"
                                name="codestudiante"
                                label="Matricula"
                                value={formik.values.codestudiante}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.codestudiante && Boolean(formik.errors.codestudiante)}
                            />
                            {formik.touched.codestudiante && formik.errors.codestudiante && (
                                <Alert severity="error">{formik.errors.codestudiante}</Alert>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ m: 1 }}>
                        <Grid item xs={12} lg={6}>
                            {ocultarBoton ?
                                <></>
                                :
                                <Button
                                    type='submit'
                                    //disabled={!isValid} 
                                    variant="contained"
                                    endIcon={<MdPersonSearch />} >
                                    Consultar
                                </Button>
                            }
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={limpiar}
                                endIcon={<MdOutlineCleaningServices />} >
                                Limpiar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                {/* <Grid container spacing={2} sx={{ m: 1, minWidth: '100%' }} justifyContent="center" alignItems="center"> */}
                {estudiante.matricula !== ''
                    ?
                    // <Grid item xs={12}>
                        <EstudiantesTabla estudiante={estudiante} />
                    // </Grid>
                    : <></>
                }
                {/* </Grid> */}
            </Container>
        </>
    );
}